'use client'

import { useEffect } from 'react'
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card'
import { ChartContainer, BarChartComponent, PieChartComponent } from "@/components/ui/charts"
import { motion, useAnimation } from 'framer-motion'
import { useInView } from 'react-intersection-observer'

export function AnalyticsSection() {
  const contractData = [
    { name: 'Federal', value: 550 },
    { name: 'State', value: 320 },
    { name: 'Local', value: 130 },
  ]

  const contractTrendData = [
    { year: '2019', value: 900 },
    { year: '2020', value: 950 },
    { year: '2021', value: 980 },
    { year: '2022', value: 1020 },
    { year: '2023', value: 1000 },
  ]

  const topCategories = [
    { category: 'Defense', value: 250 },
    { category: 'IT', value: 180 },
    { category: 'Healthcare', value: 120 },
    { category: 'Construction', value: 90 },
    { category: 'Professional Services', value: 60 },
  ]

  const controls = useAnimation()
  const [ref, inView] = useInView({
    triggerOnce: true,
    threshold: 0.1,
  })

  useEffect(() => {
    if (inView) {
      controls.start('visible')
    }
  }, [controls, inView])

  const sectionVariants = {
    hidden: { opacity: 0, y: 50 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.5 } },
  }

  return (
    <motion.section 
      ref={ref}
      className="mb-12"
      variants={sectionVariants}
      initial="hidden"
      animate={controls}
    >
      <h3 className="text-3xl font-semibold mb-6 text-center text-blue-500">Contract Analytics Dashboard</h3>
      <div className="grid gap-6 md:grid-cols-2">
        <ChartContainer title="Contract Distribution">
          <PieChartComponent
            data={contractData}
            dataKey="value"
            nameKey="name"
          />
        </ChartContainer>
        <ChartContainer title="Contract Trends">
          <BarChartComponent
            data={contractTrendData}
            xAxisDataKey="year"
            barDataKey="value"
          />
        </ChartContainer>
        <ChartContainer title="Top Contract Categories" className="md:col-span-2">
          <BarChartComponent
            data={topCategories}
            xAxisDataKey="category"
            barDataKey="value"
          />
        </ChartContainer>
      </div>
      <div className="mt-6 grid gap-6 md:grid-cols-2">
        <Card className="bg-card/50 backdrop-blur-sm border-accent-foreground/10">
          <CardHeader>
            <CardTitle className="text-2xl text-primary">Key Statistics</CardTitle>
          </CardHeader>
          <CardContent>
            <ul className="list-disc pl-5 space-y-2 text-muted-foreground">
              <li>23% of contracts awarded to small businesses</li>
              <li>15% increase in cybersecurity-related contracts</li>
              <li>30% of contracts are multi-year agreements</li>
              <li>$50 billion in R&D contracts</li>
            </ul>
          </CardContent>
        </Card>
        <Card className="bg-card/50 backdrop-blur-sm border-accent-foreground/10">
          <CardHeader>
            <CardTitle className="text-2xl text-primary">Recent Insights</CardTitle>
          </CardHeader>
          <CardContent>
            <ul className="list-disc pl-5 space-y-2 text-muted-foreground">
              <li>Increased focus on sustainable and green technologies</li>
              <li>Growing demand for AI and machine learning solutions</li>
              <li>Rise in healthcare technology and telemedicine contracts</li>
              <li>Emphasis on domestic supply chain resilience</li>
            </ul>
          </CardContent>
        </Card>
      </div>
    </motion.section>
  )
}

